import React, { useCallback, useState } from 'react'
import { selectBasketOutcomes } from 'astra-core/containers/BasketProvider'
import { setLocalStorageItem } from 'og-web-core/utils/storage/local-storage'
import { StorageKeys } from 'og-web-core/utils/storage/constants'
import { selectAccount } from 'astra-core/containers/AccountProvider/selectors'
import {
  betsProviderActions,
  selectIsQuickBetActive
} from 'astra-core/containers/BetsProvider'

import { useAppDispatch, useAppSelector } from 'store'
import { useAppFeatureFlag } from 'shared/config'

import { BasketBody, NotAuthorizedBasket } from '../BasketBody/BasketBody'
import { BasketQuickBet } from '../BasketQuickBet/BasketQuickBet'
import { BasketClearAll } from '../BasketClearAll/BasketClearAll'

export const BasketBodyWrapper = () => {
  const isBasketQuickBetEnabled = useAppFeatureFlag('BASKET_QUICK_BETS_ENABLED')
  const outcomes = useAppSelector(selectBasketOutcomes)
  const account = useAppSelector(selectAccount)
  const isQuickBetActive = useAppSelector(selectIsQuickBetActive)
  const dispatch = useAppDispatch()
  // Local state for managing the Quick Bet switch.
  // Important: Quick Bet is activated only after clicking "Save" inside the BasketQuickBetForm
  const [isActive, setIsActive] = useState(isQuickBetActive)
  const basketBodyVisible = !isActive

  // If quick bet is currently active and the user disables it,then we disable it in localStorage and send it to the store to update the global state.
  const handleSwitchQuickBet = useCallback(() => {
    if (isActive) {
      setLocalStorageItem(StorageKeys.isQuickBetActive, false)
      dispatch(betsProviderActions.setQuickBetActive({ isActive: false }))
    }
    setIsActive(!isActive)
  }, [dispatch, isActive])

  const basketQuickBet =
    outcomes.length && isActive ? (
      <BasketClearAll onClickCancel={handleSwitchQuickBet} />
    ) : (
      <BasketQuickBet
        handleSwitchQuickBet={handleSwitchQuickBet}
        isActive={isActive}
      />
    )

  if (!account) {
    return <NotAuthorizedBasket />
  }

  return (
    <>
      {isBasketQuickBetEnabled && basketQuickBet}
      {basketBodyVisible && <BasketBody />}
    </>
  )
}
